import { client } from '@antimatterhq/asl-api-ts-v1';
import { Options } from '@hey-api/client-axios';

export type DefaultOptions = Pick<Options, 'client' | 'withCredentials'>;

export const defaultOptions = (): DefaultOptions => {
  return {
    client,
    withCredentials: true,
  };
};
